import { render, staticRenderFns } from "./addedit-section.vue?vue&type=template&id=ef3cf100"
import script from "./addedit-section.vue?vue&type=script&lang=js"
export * from "./addedit-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports